var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"div"}},[_c('div',{attrs:{"id":"contact"}},[_c('img',{attrs:{"src":require("../components/images/logo_new2.png")}}),_c('p',[_vm._v("公司地址：内蒙古自治区兴安盟科尔沁右翼前旗科尔沁镇府前街南金界路西科右前旗双创产业园三楼")]),_c('p',[_vm._v("Copyright©兴安盟以恒科技有限公司")])])])
}]

export { render, staticRenderFns }